import { render, staticRenderFns } from "./SizeSelector.vue?vue&type=template&id=b2bfd5ec&lang=pug"
import script from "./SizeSelector.vue?vue&type=script&lang=js"
export * from "./SizeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports